<template>
    <Button
        severity="secondary"
        class="p-button-extra-sm"
        icon="pi pi-download"
        @click.prevent="onClick"
        text
        :loading="exporting"
        :label="$t('lang.report.dashboard.mass_download_button')"
    />
</template>

<script>
import Button from "primevue/button";
import ReportApi from "../../api/ReportApi";
import Alerts from "../../mixins/Alerts";
import CsvExportJob from "../../mixins/CsvExportJob";

export default {
    name: "MassReportDashboard",
    mixins: [Alerts, CsvExportJob],
    props: {
        domain: {
            type: String,
            required: true,
        },
        base: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            exporting: false,
        };
    },
    methods: {
        /**
         * Выгрузка строится в воркере и может занять минуты, поэтому индикатор остаётся
         * на кнопке: глобальный прелоадер всё это время держал бы страницу заблокированной.
         */
        async onClick() {
            this.exporting = true;

            try {
                const response = await ReportApi.getDashboardReports({domain: this.domain, base: this.base});
                await this.waitForCsvExport(response.job_id);
            } catch (error) {
                this.alertError(error.message);
            } finally {
                this.exporting = false;
            }
        },
    },
    components: {
        Button,
    }
}
</script>

<style scoped>
.p-button {
    box-shadow: none !important;
}
</style>
